import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ResourceTable from "../../components/ResourceTable";
import useResourceList from "./useResourceList";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Информационно-справочные ресурсы",
    link: "/work/app/reference"
  }
];

const ResourceList = ({history}) => {
  const { resData, getResources, deleteResources, createResource } = useResourceList();

  useEffect(() => {
    getResources();
  }, []);

  const selectResource = (id) => {
    history.push(`/work/app/reference/${id}`);
  }

  return (
    <div>
      <Breadcrumbs items={items} />
      {resData.resources && <ResourceTable
        deleteResources={deleteResources}
        resourcesData={resData}
        getResources={getResources}
        createResource={createResource}
        selectResource={selectResource}
      />}
    </div>
  );
};

export default ResourceList;
